import translate from '@/utils/translate';
import {CampaignInvitesResponse} from '@/api/updaters/creators';

export function hasSentCampaignInvites(result: CampaignInvitesResponse) {
  return (
    result.onPlatformInvited +
      result.offPlatformInvited +
      result.offPlatformNowOnPlatform +
      result.offPlatformEnqueued >
    0
  );
}

export default function campaignInvitesSummary(
  result: CampaignInvitesResponse
) {
  const parts: [string, number][] = [
    [
      'Invited on Popular Pays',
      result.onPlatformInvited + result.offPlatformNowOnPlatform,
    ],
    ['Invited by email', result.offPlatformInvited],
    ['Queued for email', result.offPlatformEnqueued],
    ['Opted out of emails', result.suppressed],
    ['Already invited by email', result.alreadyInvited],
    ["Couldn't be invited", result.onPlatformFailed + result.offPlatformFailed],
  ];
  return parts
    .filter(([, count]) => count > 0)
    .map(([key, count]) => translate(key, {count}))
    .join(', ');
}
